export const DROPSHIP_REVENUE = 'DROPSHIP_REVENUE';
export const DROPSHIP_ALLOWED = 'DROPSHIP_ALLOWED';
export const REPLENISH_DISCOUNT_REVENUE = 'REPLENISH_DISCOUNT_REVENUE';
export const REPLENISH_ALLOWED = 'REPLENISH_ALLOWED';
export const REPLENISH_SHIPPER_ACCOUNT = 'REPLENISH_SHIPPER_ACCOUNT';
export const PERMISSIONS_TAB = 'PERMISSIONS_TAB';
export const PERMISSIONS_MINIMUM_ORDER_PRODUCTS = 'PERMISSIONS_MINIMUM_ORDER_PRODUCTS';
export const PERMISSIONS_MINIMUM_ORDER_VALUE = 'PERMISSIONS_MINIMUM_ORDER_VALUE';
export const PERMISSIONS_PERCENTAGE = 'PERMISSIONS_PERCENTAGE';
export const PERMISSIONS_FIXED_PER_UNIT = 'PERMISSIONS_FIXED_PER_UNIT';
export const CURRENT_RETAILER_TERMS = 'CURRENT_RETAILER_TERMS';
export const PERMISSIONS_CHANGED = 'PERMISSIONS_CHANGED';
export const REPLENISH_DAYS_UNTIL_OVERDUE = 'REPLENISH_DAYS_UNTIL_OVERDUE';
export const ECOMMERCE_DAYS_UNTIL_OVERDUE = 'ECOMMERCE_DAYS_UNTIL_OVERDUE';
